<template>
  <div class="header">
    <nav
      id="navbar"
      ref="navbar"
      class="navbar navbar-expand-xl navbar-light"
      style="background-color:#fff; box-shadow:8px 8px 8px #0071BB33"
    >
      <div class="container-sm">
        <!-- logo 與品牌 -->
        <div class="navbar-brand p-0" :class="{ 'mobile-logo-centered': !isAppRoute }">
          <div class="row align-items-center">
            <div class="col">
              <router-link to="/">
                <img src="@/assets/logo.png" width="96" height="35" />
              </router-link>
            </div>
            <div class="col">
              <div class="collapse navbar-collapse" style="font-size: small;">
                {{ $t('logo') }}
              </div>
            </div>
          </div>
        </div>

        <!-- ✅ 手機版 /app：獨立在上面的「專屬學院」 -->
        <div v-if="isAppRoute" class="academy-mobile d-xl-none">
          <span class="academy-label">{{ $t('Member') }}</span>
        </div>

        <!-- 手機版漢堡 -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- 右側：根據路由切換一般模式 / 專屬學院模式 -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- ✅ /app 底下：專屬學院模式 -->
          <template v-if="isAppRoute">
            <!-- 桌機：中間顯示「專屬學院」 -->
            <div class="academy-center flex-grow-1 text-center d-none d-xl-block">
              <span class="academy-label">專屬學院</span>
            </div>

            <!-- 右側：登出 + 語言 + 社群 -->
            <div class="d-flex align-items-center ms-auto app-right-group">
              <!-- 登出按鈕（灰字版） -->
              <button
                type="button"
                class="btn btn-sm logout-btn me-2"
                @click="onSignOut"
              >
                {{ $t('common.logout') }}
              </button>

              <!-- 語言切換 -->
              <div id="lang" class="d-flex align-items-center">
                <select
                  v-model="$i18n.locale"
                  class="form-select form-select-sm lang-select"
                  style="width:90px;"
                >
                  <option
                    v-for="(langItem, i) in langs"
                    :key="`Lang${i}`"
                    :value="langItem.lang"
                  >
                    {{ langItem.name }}
                  </option>
                </select>
              </div>

              <!-- 社交平台 -->
              <form class="d-flex center ms-3">
                <ul class="navbar-nav social-nav">
                  <li class="m-1 center">
                    <a
                      href="https://www.facebook.com/TSKlabTaiwan"
                      target="_blank"
                      rel="noopener"
                    >
                      <img class="w-100 h-100" src="@/assets/images/facebook.png" />
                    </a>
                  </li>
                  <li class="m-1 center">
                    <a
                      href="https://www.instagram.com/tsk_taiwan/?igsh=eXZoZnF6aGIwaGF5"
                      target="_blank"
                      rel="noopener"
                    >
                      <img class="w-100 h-100" src="@/assets/images/ig.png" />
                    </a>
                  </li>
                  <li class="m-1 center">
                    <a
                      href="https://lin.ee/3q7G3vO3"
                      target="_blank"
                      rel="noopener"
                    >
                      <img class="w-100 h-100" src="@/assets/images/line.jpg" />
                    </a>
                  </li>
                </ul>
              </form>
            </div>
          </template>

          <!-- 🌐 一般模式：首頁 / about / product / news / member... -->
          <template v-else>
            <!-- 導覽列 -->
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              <li class="nav-item" v-for="(t, index) in tab" :key="index">
                <!-- 路由內頁用 router-link；錨點另行處理 -->
                <router-link
                  v-if="!isHashLink(t)"
                  :to="normalizeTo(t)"
                  class="nav-link active-page"
                  :class="{ active: isActive(t) }"
                  :aria-current="isActive(t) ? 'page' : null"
                  @click="onNavClick"
                >
                  {{ $t(t.name) }}
                </router-link>

                <!-- #contact 這類外部錨點 -->
                <a
                  v-else
                  :href="`/${t.to}`"
                  class="nav-link active-page"
                  :class="{ active: isActive(t) }"
                  @click="onNavClick"
                >
                  {{ $t(t.name) }}
                </a>
              </li>
            </ul>

            <!-- 語言切換 -->
            <div id="lang" class="ms-3 d-flex align-items-center">
              <select
                v-model="$i18n.locale"
                class="form-select form-select-sm lang-select"
                style="width:90px;"
              >
                <option
                  v-for="(langItem, i) in langs"
                  :key="`Lang${i}`"
                  :value="langItem.lang"
                >
                  {{ langItem.name }}
                </option>
              </select>
            </div>

            <!-- 社交平台 -->
            <form class="d-flex center ms-3">
              <ul class="navbar-nav social-nav">
                <li class="m-1 center">
                  <a
                    href="https://www.facebook.com/TSKlabTaiwan"
                    target="_blank"
                    rel="noopener"
                  >
                    <img class="w-100 h-100" src="@/assets/images/facebook.png" />
                  </a>
                </li>
                <li class="m-1 center">
                  <a
                    href="https://www.instagram.com/tsk_taiwan/?igsh=eXZoZnF6aGIwaGF5"
                    target="_blank"
                    rel="noopener"
                  >
                    <img class="w-100 h-100" src="@/assets/images/ig.png" />
                  </a>
                </li>
                <li class="m-1 center">
                  <a
                    href="https://lin.ee/3q7G3vO3"
                    target="_blank"
                    rel="noopener"
                  >
                    <img class="w-100 h-100" src="@/assets/images/line.jpg" />
                  </a>
                </li>
              </ul>
            </form>
          </template>
        </div>
      </div>
    </nav>

    <!-- 佔位元素：固定時佔住 navbar 原本的高度，避免版面跳動 -->
    <div ref="navSpacer" class="nav-spacer" aria-hidden="true"></div>
  </div>
</template>

<script>
import { supabase } from "@/lib/supabase";
import { lang, tab } from "@/config/headerConfig.js";

export default {
  name: "Header",
  data() {
    return {
      langs: lang,
      tab: tab,

      // 固定狀態 & 節流
      isFixed: false,
      rafId: 0,

      // 遲滯（hysteresis）
      fixHysteresisEnter: 12,
      fixHysteresisExit: 6,
    };
  },

  computed: {
    // 只要在 /app（含子頁）就走「專屬學院」樣式
    isAppRoute() {
      const path = this.$route.path || "/";
      return path === "/app" || path.startsWith("/app/");
    },
  },

  methods: {
    // 判斷是否為錨點（如 #contact）
    isHashLink(t) {
      return typeof t.to === "string" && t.to.startsWith("#");
    },

    // 把 tab.to 轉成實際路由 path
    normalizeTo(t) {
      const m = {
        About: "/about",
        Product: "/AllProduct",
        News: "/news",
        Member: "/member",
        Contact: "/#contact",
      };
      return m[t.name] || `/${t.to}`;
    },

    closeMobileNav() {
      const wrap = document.getElementById("navbarSupportedContent");
      if (wrap && wrap.classList.contains("show")) {
        wrap.classList.remove("show");

        const toggler = this.$refs.navbar?.querySelector(".navbar-toggler");
        if (toggler) {
          toggler.classList.add("collapsed");
          toggler.setAttribute("aria-expanded", "false");
        }
      }
    },

    // 手機版點擊選單項目後關閉展開的 navbar
    onNavClick() {
      this.closeMobileNav();
    },

    // 選單展開時，點擊非互動元件的空白處即可收合
    onDocumentClick(event) {
      if (window.innerWidth >= 1200) return;

      const wrap = document.getElementById("navbarSupportedContent");
      if (!wrap || !wrap.classList.contains("show")) return;

      const interactive = event.target.closest(
        "a, button, select, option, input, label"
      );
      if (interactive) return;

      this.closeMobileNav();
    },

    // 依目前路由判斷高亮
    isActive(t) {
      const path = this.$route.path || "/";
      const to = this.normalizeTo(t);

      if (path === "/app" || path.startsWith("/app/")) {
        return to === "/member";
      }

      if (to === "/member") {
        return path.startsWith("/member");
      }

      if (to === "/AllProduct") {
        return (
          path === "/" ||
          path.startsWith("/AllProduct") ||
          path.startsWith("/product/")
        );
      }

      if (to === "/news") {
        return path.startsWith("/news");
      }

      if (to === "/about") {
        return path.startsWith("/about");
      }

      if (this.isHashLink(t)) {
        return false;
      }

      return path.startsWith(to);
    },

    // ---- 滾動行為：rAF 節流 + 遲滯 + 短頁面保護 ----
    isScrollablePage() {
      const doc = document.documentElement;
      return doc.scrollHeight - window.innerHeight > 8;
    },

    applyFixedState(shouldFix) {
      const navbar = this.$refs.navbar;
      const spacer = this.$refs.navSpacer;
      if (!navbar || !spacer) return;

      if (shouldFix) {
        if (!this.isFixed) {
          this.isFixed = true;
          navbar.classList.add("fixed-top");
          spacer.style.height = navbar.offsetHeight + "px";
        }
      } else {
        if (this.isFixed) {
          this.isFixed = false;
          navbar.classList.remove("fixed-top");
          spacer.style.height = "0px";
        }
      }
    },

    handleScroll() {
      const navbar = this.$refs.navbar;
      if (!navbar) return;

      if (!this.isScrollablePage()) {
        this.applyFixedState(false);
        return;
      }

      const top = window.scrollY || window.pageYOffset || 0;
      const base = navbar.offsetHeight || 0;

      if (!this.isFixed) {
        const enterThreshold = base + this.fixHysteresisEnter;
        this.applyFixedState(top > enterThreshold);
      } else {
        const exitThreshold = Math.max(0, base - this.fixHysteresisExit);
        this.applyFixedState(!(top < exitThreshold));
      }
    },

    onScroll() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = 0;
        this.handleScroll();
      });
    },

    // 🔐 登出：給 /app 模式用
    async onSignOut() {
      try {
        await supabase.auth.signOut();
      } catch (e) {
        console.warn("signOut failed:", e?.message || e);
      } finally {
        this.$router.replace("/member");
      }
    },
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("click", this.onDocumentClick);
    this.$nextTick(() => this.handleScroll());
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocumentClick);
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.applyFixedState(false);
  },

  watch: {
    "$route.path"() {
      this.$nextTick(() => this.handleScroll());
    },
    "$i18n.locale"(newLang) {
      localStorage.setItem("locale", newLang);
      this.$nextTick(() => this.handleScroll());
    },
  },
};
</script>

<style lang="scss">
#lang {
  .border-gray {
    line-height: 0.8;
  }
  label.active {
    color: #5fa4b8;
    font-weight: 700;
  }
  input[type="radio"] {
    display: none;
  }
  input[type="radio"] + label {
    font-size: 0.9rem;
    a {
      text-decoration: none;
      color: black;
    }
  }
}
.navbar-nav {
  .active {
    color: #5fa4b8 !important;
    font-weight: bold;
  }
}
.social-nav {
  li {
    width: 30px;
    height: 30px;
  }
}
/* 預設 sticky；滾動後會切成 fixed-top（由 JS 控制） */
.navbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: 10000 !important;
  box-shadow: 8px 8px 8px #0071bb33;
}

/* 佔位元素：固定時由 JS 設置高度 */
.nav-spacer {
  height: 0;
  transition: height 0s;
}

#lang .lang-select {
  font-size: 0.97rem;
  padding: 2px 10px;
  background: #f6faff;
  border: 1px solid #0071bb44;
  color: #5fa4b8;
  font-weight: bold;
  border-radius: 8px;
  min-width: 80px;
  margin-right: 8px;
  transition: border-color 0.15s;
  text-align: center;
  text-align-last: center;
}
#lang .lang-select:focus {
  border-color: #0071bb;
  box-shadow: 0 0 0 2px #0071bb22;
}

@media (max-width: 1199.98px) {
  /* 讓手機 header 可以放絕對置中的專屬學院 */
  .navbar .container-sm {
    position: relative;
  }

  .navbar-brand.mobile-logo-centered {
    position: absolute;
    /* 固定在導覽列頂部列；展開選單時不跟著整個 container 高度移動 */
    top: var(--bs-navbar-padding-y, 0.5rem);
    left: 50%;
    margin: 0 !important;
    transform: translateX(-50%);
    z-index: 1;
  }

  .navbar-brand.mobile-logo-centered .row {
    margin: 0;
  }

  .navbar-brand.mobile-logo-centered .row > .col:first-child {
    width: auto;
    padding: 0;
    flex: 0 0 auto;
  }

  .navbar-brand.mobile-logo-centered .row > .col:last-child {
    display: none;
  }

  .navbar-toggler {
    margin-left: auto;
    z-index: 2;
  }

  #lang {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center;
  }
  #lang .lang-select {
    margin: 0 auto !important;
    float: none !important;
    display: block !important;
    text-align: center;
  }
  .navbar-collapse .social-nav {
    width: 100%;
    justify-content: center !important;
    display: flex !important;
    flex-direction: row;
    padding: 0;
    margin: 0 auto;
  }
  .navbar-collapse form.d-flex {
    margin: 0 !important;
    padding: 0 !important;
    justify-content: center !important;
    width: 100%;
  }
  .social-nav li {
    display: inline-block;
    width: 30px;
    height: 30px;
  }
}

/* ===== 專屬學院 ===== */
.academy-label {
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-weight: 700;
  color: #5fa4b8;
  white-space: nowrap;
}

/* 桌機中間版位 */
.academy-center {
  font-size: 1rem;
}

/* 手機版：完全置中的「專屬學院」 */
.academy-mobile {
  font-size: 0.92rem;
  display: flex;
  align-items: center;
}

@media (max-width: 1199.98px) {
  .navbar .container-sm {
    position: relative;
  }

  .academy-mobile {
    position: fixed;              /* ← 改成 fixed，跟視窗走 */
    left: 50%;
    top: 18px;                    /* ← 這個可以微調，決定垂直位置 */
    transform: translateX(-50%);  /* 只水平置中就好 */
    margin-left: 0;
    z-index: 11001;               /* 比 navbar 高一點，確保在上層 */
  }
}

/* 右側群組（登出 + 語言 + 社群） */
.app-right-group {
  display: flex;
  align-items: center;
}

/* 登出按鈕：灰字、無底色、無陰影 */
.logout-btn {
  border-radius: 0;
  border: 0;
  background: transparent;
  color: #6b7280 !important;/* ← 強制灰色 */
  font-weight: 500;
  padding: 0 8px;
  font-size: 0.9rem;
  white-space: nowrap;
  box-shadow: none;
}

.logout-btn:hover {
  background: transparent;
  color: #374151 !important;
  text-decoration: underline;
}

/* 手機時排版調整一下 */
@media (max-width: 1199.98px) {
  .app-right-group {
    width: 100%;
    justify-content: center;
    margin-top: 8px;
    flex-wrap: wrap;
    gap: 6px;
  }
}
</style>
